const hideSkeletonWhenPhotoArrives = (media) => {
  const image = media.querySelector('.gallerySectionsSlider__mediaImage');
  if (!image) {
    media.classList.add('gallerySectionsSlider__media--loaded');
    return;
  }

  if (image.complete) {
    media.classList.add('gallerySectionsSlider__media--loaded');
    return;
  }

  const showImage = () => {
    media.classList.add('gallerySectionsSlider__media--loaded');
  };

  image.addEventListener('load', showImage, { once: true });
  image.addEventListener('error', showImage, { once: true });
};

export default function initGallerySectionsSlider({ onSectionClick, onSectionVisible } = {}) {
  const slider = document.querySelector('.gallerySectionsSlider');
  if (!slider) {
    return null;
  }

  const scroll = slider.querySelector('.gallerySectionsSlider__scroll');
  const left = slider.querySelector('.gallerySectionsSlider__left');
  const right = slider.querySelector('.gallerySectionsSlider__right');
  const firstElement = slider.querySelector('.gallerySectionsSlider__element');
  const items = slider.querySelectorAll('.gallerySectionsSlider__element');

  items.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      document.querySelector(`#${item.dataset.sectionId}`)?.scrollIntoView({ behavior: 'smooth' });

      onSectionClick?.(item.dataset);
    });

    // Load image and hide skeleton when photo arrives
    const media = item.querySelector('.gallerySectionsSlider__media');
    if (media) {
      hideSkeletonWhenPhotoArrives(media);
    }
  });

  if (onSectionVisible) {
    // Rooted on the strip, so thumbnails waiting off to the right only count once scrolled to. The
    // strip sits in a hidden modal until the gallery opens, which is when the first ones report in.
    const observer = new IntersectionObserver((entries) => {
      entries.filter(entry => entry.isIntersecting).forEach((entry) => {
        observer.unobserve(entry.target);
        onSectionVisible(entry.target.dataset);
      });
    }, { root: scroll, threshold: 0.5 });

    items.forEach(item => observer.observe(item));
  }

  left.addEventListener('click', () => {
    scroll.scrollTo({ left: scroll.scrollLeft - firstElement.clientWidth, behavior: 'smooth' });
  });

  right.addEventListener('click', () => {
    scroll.scrollTo({ left: scroll.scrollLeft + firstElement.clientWidth, behavior: 'smooth' });
  });

  scroll.addEventListener('scroll', () => {
    left.classList.toggle('none', scroll.scrollLeft === 0);
    right.classList.toggle('none', scroll.scrollLeft + scroll.clientWidth === scroll.scrollWidth);
  });

  return {
    // The strip lives inside the modal, so how much of it overflows is only known once it is shown.
    showRightChevronIfScrollable() {
      if (scroll.scrollWidth > scroll.clientWidth) {
        right.classList.remove('none');
      }
    },
  };
}
